/**
 * Page-to-page motion: the photo of the card you open grows into the recipe's
 * big photo (cross-document View Transitions; CSS in components/_motion.scss).
 *
 * Only the clicked card gets the shared name — a recipe can appear in several
 * lists on one page, and two elements with one name cancel the transition.
 * Browsers without View Transitions, and visitors who reduce motion, simply
 * navigate as before.
 */
const NAME = 'recipe-photo';

export default function initMotion() {
	if (
		! ( 'onpagereveal' in window ) ||
		window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches
	) {
		return;
	}

	document.addEventListener( 'click', ( event ) => {
		const link = event.target.closest( '.recipe-card__title a' );
		if (
			! link ||
			event.defaultPrevented ||
			event.button !== 0 ||
			event.metaKey ||
			event.ctrlKey ||
			event.shiftKey ||
			event.altKey
		) {
			return;
		}
		const img = link
			.closest( '.recipe-card' )
			?.querySelector( '.recipe-card__media img' );
		if ( img ) {
			// On a recipe page the hero photo carries the name too: one element only.
			const hero = document.querySelector( '.recipe-hero__media img' );
			if ( hero ) {
				hero.style.viewTransitionName = 'none';
			}
			img.style.viewTransitionName = NAME;
		}
	} );

	// Back from the recipe (bfcache): the list must not keep the name.
	window.addEventListener( 'pageshow', () => {
		document
			.querySelectorAll(
				'.recipe-card__media img[style*="view-transition-name"], .recipe-hero__media img[style*="view-transition-name"]'
			)
			.forEach( ( img ) => {
				img.style.viewTransitionName = '';
			} );
	} );
}
